//import {COUNTRIES, PROVINCES, CITIES, ROLES} from '../constant';
 /* eslint-disable */
export default {
    state: {
        statusOk: null,
        errMessage: "",
        okMessage: "",
        creating: false
    },
    mutations: {
        'CREATE_POST_CREATING' (state, val) {
            state.creating = val;
        },
        'CREATE_POST_SUCCESS' (state, val) {
            state.statusOk = true;
            state.errMessage = "";
            state.okMessage = val;
        },
        'CREATE_POST_ERROR' (state, val) {
            state.statusOk = false;
            state.errMessage = val;
            state.okMessage = "";
        }
    },
    actions: {
        'CREATE_POST' ({commit, getters, rootState}, data) {
            console.log("data", JSON.stringify(data));
            let payload;
            if(getters.isAuthenticated) {
                payload = data.post;
            } else {
                payload = data;
                payload.user.province = data.post.province;
                payload.user.city = data.post.city;
            }
            //test------------------------------remove this-------------------------------
            payload.condition = 4;

            return new Promise((resolve, reject) => {
                commit('CREATE_POST_CREATING', true);
                //do images and videos upload first
                axios.post(getters.isAuthenticated ? '/item':'/item/user', payload)
                .then(resp => {
                    console.log("create post success",resp);
                    commit('CREATE_POST_CREATING', false);
                    const text = rootState.locale === "en" ? (getters.isAuthenticated ? 'Post successfully submitted. Click here to see your post.':'Success, click here to see your post. Please check your email to verify your confirmation.') : 
                        (getters.isAuthenticated ? 'Ilmoitus lähetetty. Paina tästä nähdäksesi ilmoituksesi.':'Ilmoitus lähetetty, paina tästä nähdäksesi ilmoituksesi. Tarkista sähköpostisi vahvistaaksesi rekisteröitymisen.');
                    commit('CREATE_POST_SUCCESS', {link: `/post/${resp.data.response._id}`, text });
                    resolve(resp);
                })
                .catch(err => {
                    commit('CREATE_POST_CREATING', false);
                    const errTxt = err.response ? (err.response.data ? (err.response.data.errTxt ? err.response.data.errTxt : undefined): undefined) : undefined;
                    commit('CREATE_POST_ERROR', (err.status === 409 && getters.isAuthenticate) ? (rootState.locale === "en" ? 'Duplicate email detected. Email already taken.': 'Sähköpostiosoite on jo käytössä'):(errTxt ? errTxt : 'Error. Server Error'));
                    console.log("count posts err", err.response);
                    reject(err);
                });
            });
        }
    }
};